import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './StatusBadge.module.scss';
export const StatusBadge = ({ label, bgColor, color }) => {
    const badgeStyle = {
        backgroundColor: bgColor,
        color,
        borderColor: color,
    };
    return (_jsx("div", { className: styles.container, children: _jsxs("div", { className: styles.statusBadge, style: badgeStyle, children: [_jsx("i", { className: `fas fa-circle fa-xs ${styles.statusDot}`, "aria-hidden": "true" }), _jsx("span", { className: styles.statusLabel, children: label })] }) }));
};
